export default __webpack_public_path__ + "static/media/gallery-frogs_01.95af2863.jpg";